import { twClassMerge } from '@healthhub/react-ui';
import type { RadioProps } from 'antd';
import { Radio as AntdRadio } from 'antd';
import { memo } from 'react';


import styles from './styles.module.css';

const CustomRadio = ({ className, ...props }: RadioProps) => (
  <AntdRadio {...props} className={twClassMerge(styles.radio, className)} />
);

export default memo(CustomRadio);
